import axios from 'axios';
import { get } from 'lodash/fp';
import { GLOBAL_ERROR } from './actionTypes';
import loaded from './loaded';

export default ({
  text = null,
  reload = false,
  err = null,
}) => (dispatch) => {
  if (!axios.isCancel(err)) {
    const message = text || get('message')(err);
    // eslint-disable-next-line no-console
    if (message) console.error(message);

    dispatch({
      type: GLOBAL_ERROR,
      errorMessage: message,
      reloadOnClose: reload,
    });

    dispatch(loaded());
  }
};
